export const base = 4
export const gutter = 24
export const maxPageWidth = 1216

export const sm = 480
export const md = 768
export const lg = 1024
